import axios from "../axios";
import { useState, useEffect } from "react";
import urls from "../Utils/urls";
import { useAbortController } from "./useAbortController";
import { loadingTypes } from "../Utils/constant";

const useBorowerLoanDetail = (accountId) => {
  const [loanDetails, setLoanDetails] = useState({
    loanTerm: {},
    loanOverview: {},
    borrowOverview: {},
  });
  const [status, setStatus] = useState(loadingTypes.idle);
  const { signal } = useAbortController();

  useEffect(() => {
    const fetchData = async () => {
      setStatus(loadingTypes.loading);
      try {
        const res = await axios?.get(urls.dashboard.getLoanTerm2(accountId), {
          signal,
        });
        if (res.data[0] && res.data[0].length > 0) {
          const data = transformLoanData(res.data[0][0]);
          setLoanDetails(data);
          setStatus(loadingTypes.fulfilled);
        }
      } catch (error) {
        setStatus(loadingTypes.error);
        if (error.name === "CanceledError") {
          console.error("Fetch request canceled", error.message);
        } else {
          // console.error(error);
          console.error("Error fetching loan details:", error);
        }
      }
    };

    if (accountId) {
      fetchData();
    }
  }, [accountId]);

  return { loanDetails, status };
};

export const transformLoanData = (data) => {
  // Split the loan header if it exists and is a string
  const loanHeaders = data?.loanheader?.split("<br />") || [];

  // Extract and parse ACH status from HTML string
  const achStatusHtml = document.createElement("div");
  achStatusHtml.innerHTML = data.ach_status || "";
  const achStatus = achStatusHtml.querySelector("strong")?.innerHTML || "";

  // Extract and parse ACH info from HTML string
  const achInfoHtml = document.createElement("div");
  achInfoHtml.innerHTML = data.ach_info || "";
  const achInfoLinkText = achInfoHtml.querySelector("a")?.innerHTML || "";
  const achInfoLinkHref =
    achInfoHtml.querySelector("a")?.getAttribute("href") || "";

  // Set borrowerLoanId in local storage
  const borrowerLoanId = achInfoLinkHref.split("=")[1];
  localStorage.setItem("borrowerLoanId", borrowerLoanId);

  // Construct the transformed data structure
  return {
    loanTerm: {
      loanheader1: loanHeaders[0] || "",
      loanheader2: loanHeaders[1] || "",
      achStatus,
      achInfo1: achInfoLinkText,
      achInfo2: achInfoLinkHref,
      loanStatus: data.statuses,
    },
    loanOverview: {
      "Loan Amount": data.loan_amount,
      "Unpaid Principal Balance": data.unpaid_principal_balance,
      "Loan Maturity Date": data.loan_maturity_date,
      "Next Due Date": data.next_due_date,
      "Reserve Balance": data.balance_reserve,
      "Impound Balance": data.balance_impound,
      "Current Principal and Interest Due": data.current_pi_due,
      "Unpaid Late Charges": data.unpaid_late_charges,
      "Unpaid Interest": data.unpaid_interest,
      "Reserve Payment": data.payment_reserve,
      "Impound Payment": data.payment_impound,
      "Other Charges": data.other_charges,
      "Current Total Amount Due": data.current_amount_due,
      "Loan Stop Date": data.ACH_StopDate,
    },
    borrowOverview: {
      "Borrower Name": data.borrower_name,
      "Main Contact": `${data.borrower_first_name} ${data.borrower_last_name}`,
      "Borrower Address": `${data.borrower_address}
        ${data.borrower_city} ${data.borrower_state}, ${data.borrower_zip_code}`,
      "Borrower Email": data.borrower_email,
      "Home Phone": data.borrower_home_phone,
      "Mobile Phone": data.borrower_mobile_phone,
      "Work Phone": data.borrower_work_phone,
      // "Tax ID (last 4 digits)": "****",
      "Tax ID (last 4 digits)": data.last_4_tax_id,
      "Account Number": data.account,
    },
  };
};

export default useBorowerLoanDetail;
